import APIService from '@/services/APIService';
import Conference from '@/models/list/Conference';

export default {
  /**
   * Получить хеш для телеграм-бота для привязки аккаунта сдо к акканту телеги
   */
  userHash() {
    return APIService.post('/telegram/assign-code', null, { rOptions: { single: true } });
  },

  notifications() {
    return APIService.get('/telegram/notifications', null);
  },

  /**
   * Конференции в телеграмме CRUD
   *
   * @returns {
      "id": 1,
      "title": "Test conferense",
      "lesson_id": null,
      "teacher_id": 4,
      "type": 1,
      "status": 1,
      "date_start": "2022-11-28T11:00:00.000000Z",
      "conference": {
        "video_call": {
          "message": "Test conferense",
          "status": 6,
          "schedule_date": "2022-11-28T11:00:00.000000Z",
          "created_date": "2022-11-28T10:00:00.000000Z"
        },
        "group": {
          "telegram_title": "Курс Telegram 2",
          "invite_link": "https:\/\/t.me\/+imh9GNMspOdmNzQy"
        }
      }
   */
  conferenceIndex(params) {
    return APIService.get('/conferences', { params, rOptions: { many: true, model: Conference } });
  },
  conferenceShow(id, params) {
    return APIService.get(`/conferences/${id}`, { params, rOptions: { single: true } });
  },
  conferenceCreate(data, obs) {
    return APIService.post('/conferences', data, { rOptions: { obs } });
  },
  conferenceUpdate(id, data) {
    return APIService.put(`/conferences/${id}`, data);
  },
  conferenceDelete(id, data) {
    return APIService.delete(`/conferences/${id}`, data);
  },

  enrollmentChannel(enrollmentId) {
    return APIService.post(`/telegram/create-prior-record-channel/${enrollmentId}`);
  },
  groupChannel(groupId) {
    return APIService.post(`/telegram/create-group-channel/${groupId}`);
  },

  setTelegramCourseStorage(courseId, params) {
    return APIService.post(`/telegram/create-course-file-channel/${courseId}`, params);
  },
  setTelegramModuleStorage(courseId, params) {
    return APIService.post(`/telegram/create-course-module-file-channel/${courseId}`, params);
  },
  updateTelegramChannel(id, params) {
    return APIService.put(`/telegram/${id}`, params);
  },

  createTelegramStorageLink(id, params) {
    return APIService.post(`/lessons/${id}/contents/telegrams`, params);
  },
  updateTelegramStorageLink(id, params) {
    return APIService.put(`/lessons/contents/telegrams/${id}`, params);
  },
  deleteTelegramStorageLink(id, params) {
    return APIService.delete(`/lessons/contents/telegrams/${id}`, params);
  },

  checkUserInGroup(id, params) {
    return APIService.post(`/telegram/check-channel-users/${id}`, params);
  },
};
